const copyHrefToClipboard = () => {
	navigator.clipboard.writeText(window.location.href)
}

export { copyHrefToClipboard }
